import React, { createContext, useState, useContext, useEffect } from "react";
import { safeGetItem, safeSetItem } from "../utils/storage";

// Create a Context for the navigation state
export const NavigationContext = createContext();

// Create a Provider component
const NavigationProvider = ({ children }) => {
  const [isDesktopSidebarExpanded, setDesktopSidebarExpanded] = useState(
    safeGetItem("isDesktopSidebarExpanded") === "true" || false
  );

  const toggleDesktopSidebar = () => {
    setDesktopSidebarExpanded((prevState) => !prevState);
  };

  useEffect(() => {
    safeSetItem("isDesktopSidebarExpanded", String(isDesktopSidebarExpanded));
  }, [isDesktopSidebarExpanded]);

  return (
    <NavigationContext.Provider value={{ isDesktopSidebarExpanded, toggleDesktopSidebar }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
